var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isMobileLogin,
          expression: "!isMobileLogin"
        }
      ],
      staticClass: "home"
    },
    [
      _c("HeaderLandingNew"),
      _vm._v(" "),
      _c("HeaderLandingNew", { attrs: { "custom-class": "z-index-2" } }),
      _vm._v(" "),
      _c("HeaderLandingContent"),
      _vm._v(" "),
      _c("div", { staticClass: "container-section " }, [
        _c(
          "div",
          { staticClass: "content-section-2" },
          [
            _c(
              "b-container",
              {
                staticClass: "mt-5 mb-5",
                staticStyle: { "min-height": "65vh" },
                attrs: { fluid: "" }
              },
              [
                _c(
                  "b-row",
                  { attrs: { "align-h": "center" } },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c(
                          "b-form",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center",
                            on: { submit: _vm.login }
                          },
                          [
                            _c(
                              "b-nav",
                              {
                                staticClass:
                                  "mb-5 justify-content-center nav-signin",
                                attrs: { pills: "" }
                              },
                              [
                                _c(
                                  "b-nav-item",
                                  { attrs: { href: "/#/register" } },
                                  [_vm._v("Sign Up")]
                                ),
                                _vm._v(" "),
                                _c("b-nav-item", { attrs: { active: "" } }, [
                                  _vm._v("Log In")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.showFormEmail
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-100 d-flex justify-content-start align-items-center",
                                      staticStyle: { "margin-bottom": "32px" }
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "cursor-pointer text-decoration-none",
                                          staticStyle: { color: "#4d4d4d" },
                                          on: {
                                            click: function($event) {
                                              _vm.showFormEmail = false
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "icon-back",
                                            staticStyle: {
                                              "margin-right": "20px"
                                            },
                                            attrs: {
                                              icon: ["fas", "arrow-left"]
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-size": "20px",
                                                "line-height": "24px"
                                              }
                                            },
                                            [_vm._v("Back")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    { staticClass: "font-weight-bolder mb-4" },
                                    [_vm._v("Log In with Email")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-4 w-100",
                                      attrs: { id: "input-group-1" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          id: "input-1",
                                          type: "email",
                                          placeholder: "Enter email",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.email,
                                          callback: function($$v) {
                                            _vm.email = $$v
                                          },
                                          expression: "email"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "w-100",
                                      attrs: { id: "input-group-2" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: "password",
                                          id: "input-2",
                                          placeholder: "Enter Password",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "w-100" }),
                                      _vm._v(" "),
                                      _vm.getStatus !== 200 &&
                                      _vm.getErrorCode === "ER-AUTH-02"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-danger text-left"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.getMessage) + ". "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-block",
                                      attrs: {
                                        type: "submit",
                                        variant: "primary"
                                      }
                                    },
                                    [_vm._v("Log In")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "d-flex justify-content-end mt-2 text-dark",
                                      attrs: { href: "/#/forgot-password" }
                                    },
                                    [_vm._v("Forgot Password?")]
                                  )
                                ]
                              : [
                                  _c(
                                    "h4",
                                    { staticClass: "font-weight-bolder mb-4" },
                                    [_vm._v("Log In to Your Account")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-block btn-social",
                                      attrs: {
                                        type: "button",
                                        variant: "default"
                                      },
                                      on: { click: _vm.signInFB }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/fb-icon.svg"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  Log In with Facebook\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-block btn-social",
                                      attrs: {
                                        type: "button",
                                        variant: "default"
                                      },
                                      on: { click: _vm.signInGoogle }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/google-icon.svg"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  Log In with Google\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-block btn-social",
                                      attrs: {
                                        type: "button",
                                        variant: "default"
                                      },
                                      on: { click: _vm.signInApple }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/apple-icon.svg"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  Log In with Apple\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "btn-block btn-social",
                                      attrs: {
                                        type: "button",
                                        variant: "default"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.showFormEmail = true
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/mail-icon.svg"),
                                          alt: "logo"
                                        }
                                      }),
                                      _vm._v(
                                        "\n                  Log In with Email\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center",
                                      staticStyle: {
                                        "margin-top": "56px",
                                        "margin-bottom": "23px",
                                        "font-size": "16px",
                                        "line-height": "19px"
                                      }
                                    },
                                    [_vm._v("Don’t Have an Account?")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "button",
                                        variant: "primary"
                                      },
                                      on: { click: _vm.goToRegister }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Sign Up\n                "
                                      )
                                    ]
                                  )
                                ],
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "border-bottom border-dark mb-3",
                              staticStyle: { "margin-top": "89px" }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-center" }, [
                              _vm._v(
                                "Download MusicVerse. Your one-stop app for sacred music"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "justify-content-center align-items-center flex-column flex-sm-row"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                                    attrs: {
                                      href: _vm.appStoreUrl,
                                      "aria-label": "App Store",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "content-logo",
                                      attrs: {
                                        src: require("@/assets/applestore-logo.png"),
                                        alt: "App Store"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo",
                                    attrs: {
                                      href: _vm.googlePlayUrl,
                                      "aria-label": "Google Play",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "content-logo",
                                      attrs: {
                                        src: require("@/assets/googleplay-logo.png"),
                                        alt: "Google Play"
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "mt-3 mt-xl-0 content-logo radius",
                                    attrs: {
                                      href: _vm.appGalleryUrl,
                                      "aria-label": "App Gallery",
                                      target: "_blank",
                                      rel: "noopener noreferrer"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "content-logo radius",
                                      attrs: {
                                        src: require("@/assets/huawei-logo.png"),
                                        alt: "App Gallery"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("FooterLandingNew")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b7a3d48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7a3d48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signin.vue
// module id = null
// module chunks = 